import { YAxis } from 'recharts';

// @ts-ignore
YAxis.defaultProps.stroke = 'none';
// @ts-ignore
YAxis.defaultProps.tickLine = false;
// @ts-ignore
YAxis.defaultProps.tickMargin = 10;

export { YAxis };
